import Calendar from "color-calendar";
import "color-calendar/dist/css/theme-basic.css";

const current_language = __blank__.language;
let path;
if (current_language === 'en-US') {
    path = '/en';
} else if (current_language === 'fr-FR') {
    path = '/fr';
} else {
    path = '';
}

const calendar_weekdays = JSON.parse(__blank__.translations.calendar_weekdays);
const calendar_url = __blank__.translations.calendar_url;
const calendar_events = __blank__.events.calendar_events;

const calendar = document.querySelector('#blank-calendar')

function addLeadingZero(integer) {
    const string = String(integer)
    return ('0' + (string)).slice(-2)
}

/**
 * we set a mini-delay, cause the "dateChanged" event from calendar will fire on init. i dont see another method on how to know if the event was init or clicked (on init, it will trigger document.location.href === page reload).
 * the other trigger "selectedDateClicked" required double-click on the selected date
 */
let calendar_initialized = false
setTimeout(() => {
    calendar_initialized = true
}, 1000)


// let mouseDown = 0;
// document.body.onmousedown = function() {
//     ++mouseDown;
// }
// document.body.onmouseup = function() {
//     --mouseDown;
// }

let previousMonth = new Date().getMonth()


if (!!calendar) {
    //https://github.com/PawanKolhe/color-calendar

    new Calendar({
        id: "#blank-calendar",
        theme: "basic",
        customWeekdayValues: calendar_weekdays,
        startWeekday: 1,
        headerColor: 'var(--wp--preset--color--primary)',
        weekdaysColor: 'var(--wp--preset--color--primary)',
        primaryColor: 'var(--wp--preset--color--primary)',
        fontFamilyHeader: 'var(--wp--preset--font-family--din-2014)',
        fontFamilyWeekdays: 'var(--wp--preset--font-family--din-2014)',
        fontFamilyBody: 'var(--wp--preset--font-family--din-2014)',

        eventsData: calendar_events,
        dateChanged(currentDate, filteredDateEvents) {
            const currentMonth = currentDate.getMonth()

            if (currentMonth !== previousMonth) {
                //user changed the month only, so we dont trigger page load.
                previousMonth = currentMonth
                return false
            }

            // if (filteredDateEvents.length === 0) {
            //     return false
            // }

            // if (filteredDateEvents[0].start) {
            //     currentDate.setHours(0, 0, 0, 0)
            //     const date = new Date(filteredDateEvents[0].start)
            //     date.setHours(0, 0, 0, 0)
            //     if (date.getTime() === currentDate.getTime() && calendar_initialized) {
            //         const date_string = `${currentDate.getFullYear()}-${addLeadingZero(currentDate.getMonth() + 1)}-${addLeadingZero(currentDate.getDate())}`
            //         document.location.href = `${document.location.origin}${calendar_url}${date_string}`
            //     }
            // }

            currentDate.setHours(0, 0, 0, 0)
            if (calendar_initialized) {
                const date_string = `${currentDate.getFullYear()}-${addLeadingZero(currentDate.getMonth() + 1)}-${addLeadingZero(currentDate.getDate())}`
                document.location.href = `${document.location.origin}${path}${calendar_url}${date_string}`
            }
            // }
        },
        // selectedDateClicked(currentDate, filteredMonthEvents) {
        //     if (filteredMonthEvents[0].start) {
        //         const date_string = `${currentDate.getFullYear()}-${addLeadingZero(currentDate.getMonth() + 1)}-${addLeadingZero(currentDate.getDate())}`
        //         document.location.href = `${document.location.origin}${calendar_url}${date_string}`
        //     }
        // }
    })
}

const getPreviousElements = function (elem) {
    const siblings = [];
    let prev = elem.previousElementSibling;
    while (prev) {
        siblings.push(prev);
        prev = prev.previousElementSibling
    }

    return siblings;
};

function nav_mousemove(event) {
    const div = document.querySelector('.navigation-main--background')

    if (div) {
        const colors = [
            'primary',
            'secondary',
            'tertiary',
            'quaternary',
            'quinary',
            'senary'
        ];

        const parent = event.target.closest('.menu-item-has-children');
        if (parent) {
            const key = getPreviousElements(parent).length;
            div.style.height = parent.querySelector('.sub-menu').offsetHeight + 'px'
            div.style.backgroundColor = 'var(--wp--preset--color--' + colors[key] + ')'
        }
    }
}

function nav_mouseout() {
    const div = document.querySelector('.navigation-main--background')

    if (div) {
        div.style.height = 0;
    }
}

function registerNavigationBackground() {
    /**
     * navigation mouseover backgrund
     * (desktop only)
     */
    const bellow = document.querySelector('.bellow-navigation')
    const navigation_main = document.querySelector('#modal-1-content')

    if (bellow && navigation_main) {
        const div = document.createElement('div');
        div.classList.add('navigation-main--background')
        bellow.parentNode.insertBefore(div, bellow.nextSibling);

        navigation_main.addEventListener('mousemove', nav_mousemove)
        navigation_main.addEventListener('mouseout', nav_mouseout)
    }
}

function deregisterNavigationBackground() {
    const div = document.querySelector('.navigation-main--background')
    const navigation_main = document.querySelector('#modal-1-content')
    if (div) {
        div.remove()
    }
    if (navigation_main) {
        navigation_main.removeEventListener('mousemove', nav_mousemove)
        navigation_main.removeEventListener('mouseout', nav_mouseout)
    }
}

(function () {
    'use strict';

    // Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
    const isMobile = window.matchMedia(
        '(max-width: ' + getComputedStyle(document.body).getPropertyValue('--wp--custom--media-max-width--sm') + ')'
    );
    const navigationResponsiveContainer = document.querySelector(
        '.site-header .wp-block-navigation__responsive-container'
    );
    isMobile.addEventListener('change', ({matches}) => {
        if (matches) {
            // <= Mobile

            deregisterNavigationBackground();
        } else {
            // > Mobile

            // Autoclose header nav container if modal is open and browser window gets resized.
            if (
                document.body.contains(navigationResponsiveContainer) &&
                navigationResponsiveContainer.classList.contains('is-menu-open')
            ) {
                document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
            }

            registerNavigationBackground();
        }
    });

    isMobile.dispatchEvent(new MediaQueryListEvent('change', isMobile));

    const menu = document.querySelector('#menu-1')
    const menuOpen = document.querySelector('#menu-open-1')
    const menuClose = document.querySelector('#menu-close-1')
    menuOpen.addEventListener('click', () => {
        menu.classList.add('is-menu-open')
    })
    menuClose.addEventListener('click', () => {
        menu.classList.remove('is-menu-open')
    })

    // Style password protected post form.
    const passwordButton = document.querySelector('.post-password-form [type="submit"]');
    if (document.body.contains(passwordButton)) {
        const passwordButtonWrapper = document.createElement('div');
        passwordButtonWrapper.classList.add('wp-block-button');
        passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
        passwordButtonWrapper.appendChild(passwordButton);

        passwordButton.classList.add('wp-block-button__link');
    }

    //newsletter
    const newsletterForm = document.querySelectorAll('.newsletter--form');
    if (newsletterForm.length) {
        newsletterForm.forEach(form => {
            form.addEventListener('submit', event => {
                event.preventDefault();

                const {ajax_url, ajax_nonce} = __blank__.routing
                const response_form = event.target.querySelector('.form--response')
                const data = new FormData()
                data.append('action', 'newsletter_signup')
                data.append('nonce', ajax_nonce)
                data.append('email', event.target.querySelector('.newsletter--email').value)

                fetch(ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: data
                })
                    .then(response => response.json())
                    .then(response => {
                        let res = ''
                        const success = response.status === 'success'
                        if (success) {
                            res = response.message
                        } else {
                            const text = response.message
                            const pattern = /"detail":\s?"([^"]*)"/;
                            const result = pattern.exec(text);

                            if (result) {
                                res = result[1]
                            } else {
                                res = response.message
                            }
                        }
                        response_form.innerText = res
                    })
                    .catch(error => {
                        console.log('error', error)
                    })
            })
        })
    }

    //dropdown menus
    const selectBoxes = document.querySelectorAll('.dropdown');
    if (selectBoxes) {
        selectBoxes.forEach(selectBox => {
            const display = selectBox.querySelector('.dropdown-display');
            const options = selectBox.querySelector('.dropdown-options');
            const selectElement = selectBox.querySelector('select');
            const optionItems = options.querySelectorAll('li');

            display.addEventListener('click', () => {
                options.style.display = options.style.display === 'block' ? 'none' : 'block';
            });

            optionItems.forEach((item, index) => {
                item.addEventListener('click', () => {
                    display.textContent = item.textContent;
                    selectElement.selectedIndex = index;
                    options.style.display = 'none';

                    document.location.href = selectElement[index + 1].value;
                });
            });

            document.addEventListener('click', (event) => {
                if (!selectBox.contains(event.target)) {
                    options.style.display = 'none';
                }
            });
        })
    }
})();
